import { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

const getJobCards = () => {
  const [jobCards, setJobCards] = useState([]);

  const {
    allWorkdayJob: { edges },
  } = useStaticQuery(graphql`
    query {
      allWorkdayJob {
        edges {
          node {
            ...WorkdayJob
          }
        }
      }
    }
  `);

  useEffect(() => {
    const jobData = edges.map(({ node }) => ({
      title: node.title,
      absolute_url: node.url,
      description: node.jobDescription,
      department: node.jobFamilyGroup,
      locations: node.locations,
    }));

    setJobCards(
      [...new Set(jobData.map(x => x.department))].map(x => ({
        name: x,
        description: '',
        jobs: jobData.filter(y => y.department === x),
      }))
    );
  }, []);

  return jobCards;
};

export default getJobCards;
